// src/hooks/useSession.js
import { useEffect, useState } from 'react';

export default function useSession() {
  const [session, setSession] = useState(() => {
    try { return JSON.parse(localStorage.getItem('session') || 'null'); }
    catch { return null; }
  });

  useEffect(() => {
    const read = () => {
      try { setSession(JSON.parse(localStorage.getItem('session') || 'null')); }
      catch { setSession(null); }
    };
    const onStorage = (e) => { if (e.key === 'session') read(); };

    window.addEventListener('storage', onStorage);
    window.addEventListener('sessionchange', read); // <-- react instantly
    window.addEventListener('focus', read);

    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('sessionchange', read);
      window.removeEventListener('focus', read);
    };
  }, []);

  return session;
}